var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import i18n from '@/i18n';
let AWeekPicker = class AWeekPicker extends Vue {
    constructor() {
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.isLoading = true;
        this.currentYear = DateTime.local().year;
        this.selectedWeek = {
            weekNumber: DateTime.local().weekNumber,
            startsAt: '',
            startsAtLabel: '',
            endsAt: '',
            endsAtLabel: '',
            isCurrentWeek: false,
            year: DateTime.local().year,
        };
        this.selectedWeeks = [];
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        if (this.startsAtDate) {
            const date = DateTime.fromISO(this.startsAtDate);
            this.currentYear = date.year;
            this.selectedWeek =
                this.weeksOfCurrentYear.find((w) => w.weekNumber === date.weekNumber && w.year === date.year) || this.selectedWeek;
        }
        if (this.startsAtDates && this.startsAtDates.length > 0) {
            const dates = this.startsAtDates.map((d) => DateTime.fromISO(d));
            if (dates.length > 0) {
                this.currentYear = dates[0].year;
            }
            this.selectedWeeks = this.weeksOfCurrentYear.filter((w) => dates.some((d) => d.weekNumber === w.weekNumber && d.year === w.year));
        }
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    onPreviousYear() {
        this.currentYear--;
    }
    onNextYear() {
        this.currentYear++;
    }
    onSelectWeek(week) {
        if (this.variant === 'multiple') {
            const index = this.selectedWeeks.findIndex((w) => w.weekNumber === week.weekNumber && w.year === week.year);
            if (index === -1) {
                this.selectedWeeks.push(week);
            }
            else {
                this.selectedWeeks.splice(index, 1);
            }
            this.$emit('selected:weeks', this.selectedWeeks);
        }
        else {
            this.selectedWeek = week;
            this.$refs.menu.isActive = false;
            this.$emit('selected:week', week);
        }
    }
    // #endregion
    // #region Class methods
    submitHandler() {
        if (!this.selectedWeeks || this.selectedWeeks.length <= 0)
            return;
        this.$refs.menu.isActive = false;
    }
    isWeekSelected(week) {
        if (this.variant === 'multiple') {
            return this.selectedWeeks.some((w) => w.weekNumber === week.weekNumber && w.year === week.year);
        }
        return (this.selectedWeek?.weekNumber === week.weekNumber && this.selectedWeek?.year === week.year);
    }
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get currentWeek() {
        const startOfWeek = DateTime.local().startOf('week');
        return {
            weekNumber: startOfWeek.weekNumber,
            startsAt: startOfWeek.toISODate(),
            startsAtLabel: startOfWeek.setLocale(this.currentLocale).toFormat('d MMM'),
            endsAt: startOfWeek.plus({ days: 4 }).toISODate(),
            endsAtLabel: startOfWeek.plus({ days: 4 }).setLocale(this.currentLocale).toFormat('d MMM'),
            isCurrentWeek: true,
            year: startOfWeek.year,
        };
    }
    get weeksOfCurrentYear() {
        const weeks = [];
        const firstDayOfYear = DateTime.local(this.currentYear, 1, 1);
        const lastDayOfYear = DateTime.local(this.currentYear, 12, 31);
        let startOfWeek = firstDayOfYear.startOf('week');
        let weekNumber = startOfWeek.weekNumber;
        while (startOfWeek <= lastDayOfYear) {
            const endOfWeek = startOfWeek.plus({ days: 4 });
            weeks.push({
                weekNumber,
                startsAt: startOfWeek.toISODate(),
                startsAtLabel: startOfWeek.setLocale(this.currentLocale).toFormat('d MMM'),
                endsAt: endOfWeek.toISODate(),
                endsAtLabel: endOfWeek.setLocale(this.currentLocale).toFormat('d MMM'),
                isCurrentWeek: weekNumber === this.currentWeek.weekNumber && startOfWeek.year === this.currentWeek.year,
                year: startOfWeek.year,
            });
            startOfWeek = startOfWeek.plus({ weeks: 1 });
            weekNumber = startOfWeek.weekNumber;
        }
        return weeks;
    }
    get currentLocale() {
        if (!i18n || !i18n.locale) {
            return 'nl';
        }
        return i18n.locale;
    }
    get activatorValue() {
        if (this.variant === 'multiple') {
            if (this.selectedWeeks.length === 0) {
                return '';
            }
            return this.selectedWeeks
                .map((week) => {
                const foundWeek = this.weeksOfCurrentYear.find((w) => w.weekNumber === week.weekNumber);
                if (foundWeek) {
                    return `${foundWeek.startsAtLabel} - ${foundWeek.endsAtLabel}`;
                }
                return '';
            })
                .join(', ');
        }
        if (this.selectedWeek) {
            const week = this.weeksOfCurrentYear.find((w) => w.weekNumber === this.selectedWeek?.weekNumber);
            if (week) {
                return `${week.startsAtLabel} - ${week.endsAtLabel}`;
            }
        }
        return '';
    }
    // #endregion
    // #region @Watchers
    get isMultiple() {
        return this.variant === 'multiple';
    }
};
__decorate([
    Prop({ default: '' }),
    __metadata("design:type", String)
], AWeekPicker.prototype, "startsAtDate", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], AWeekPicker.prototype, "startsAtDates", void 0);
__decorate([
    Prop({ default: 'single' }),
    __metadata("design:type", String)
], AWeekPicker.prototype, "variant", void 0);
AWeekPicker = __decorate([
    Component({})
], AWeekPicker);
export default AWeekPicker;
// #endregion
// #region Constants
// #endregion
